(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["storefront-password-content"] && !Shopify.designMode) return;
  try {
    
  // Fix for Safari mobile viewport height
  function setViewportHeight() {
    document.documentElement.style.setProperty(
      '--vh',
      `${window.innerHeight * 0.01}px`
    );
  }

  setViewportHeight();

  ['resize', 'orientationchange'].forEach(event => {
    window.addEventListener(event, setViewportHeight);
  });

  } catch(e) { console.error(e); }
})();
})();
